import { AxiosResponse } from 'axios';

import { axios } from '@funnels/api';
import { REDUX_STORE } from '@funnels/constants';
import { ActiveRoles } from '@funnels/types';
import { datadogUtil, safelyParseJSON } from '@funnels/utils';

import { setApplicationLocked, updateActiveRoles, updateActiveRolesError } from '../actions';

const getActiveRolesHeader = (response: AxiosResponse): string | undefined =>
  response?.headers?.[REDUX_STORE.ACTIVE_ROLES.HEADER_ACTIVE_ROLES];
const parseActiveRolesHeader = (header: string) =>
  safelyParseJSON<ActiveRoles | REDUX_STORE.ACTIVE_ROLES.ACTIVE_ROLES_VALUES>(header);

axios.interceptors.response.use(async (response) => {
  const activeRolesHeader = getActiveRolesHeader(response);

  if (!activeRolesHeader) {
    return response;
  }

  const isReadonlyHeader = activeRolesHeader === REDUX_STORE.ACTIVE_ROLES.ACTIVE_ROLES_VALUES.APP_READONLY;

  // @ts-ignore
  if (isReadonlyHeader && window && window?.store) {
    // @ts-ignore
    const TVStores = window.store;

    TVStores.forEach((store: any) => {
      store.dispatch(setApplicationLocked(true));
    });

    return response;
  }

  const { store: CVStore } = await import('../index');

  const roles = parseActiveRolesHeader(activeRolesHeader);

  if (roles.error) {
    CVStore.dispatch(updateActiveRolesError(roles.error));
    datadogUtil.addError(`Error occurred when parsing active-roles header from api ${activeRolesHeader}`);
    return response;
  }

  if (Array.isArray(roles.value)) {
    CVStore.dispatch(updateActiveRoles(roles.value));
  }

  return response;
});

export { axios };
